// extracted by mini-css-extract-plugin
export default {"wrapper":"h9YO1+CtKc","capture":"_53vLJXAjet","capture-wrapper":"ziBovLgEaT","captureWrapper":"ziBovLgEaT","video":"+pcCKPEVGv","msg":"_1v6qCoB1Ie"};